import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from './components/navigation/navigation.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpErrorInterceptor } from './errors/http-error.interceptor';
import { TokenInterceptor } from './services/Interceptor/http.interceptor';
import { MiniBasketComponent } from './components/toolbar/mini-basket/mini-basket.component';
import { ResolverService } from './services/resolver/resolver.service';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './services/loader/loader.service';
import { MaterialModule } from '../material/material.module';
import { ConditionsGuard } from './services/conditions/conditions.guard';
import { ResponsiveSidenavDirective } from './directives/responsive-sidenav.directive';
import { LogService } from './services/log/log.service';
import { LogResolverService } from './services/log/log-resolver.service';
import { PermissionService } from './services/permission/permission.service';
import { SharedModule } from '../shared/shared.module';

export const httpErrorInterceptorProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true,
    deps: []
  },
];

export const httpTokenInterceptorProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }
]

@NgModule({
  declarations: [ToolbarComponent, NavigationComponent, MiniBasketComponent, LoaderComponent, ResponsiveSidenavDirective],

  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    SharedModule
  ],

  exports: [
    ToolbarComponent,
    NavigationComponent,
    MaterialModule,
    HttpClientModule,
    LoaderComponent,
    ResponsiveSidenavDirective,
  ],

  providers: [
    httpErrorInterceptorProvider,
    httpTokenInterceptorProvider,
    ResolverService,
    LogResolverService,
    LogService,
    LoaderService,
    PermissionService,
    ConditionsGuard
  ]


})

export class CoreModule { }
